//#region Libraries
import styled from "styled-components";
//#endregion
//#region Libraries
import boxIcon from "./icons/box.svg";
//#endregion

export const Container = styled.div`
    display: flex;
    gap: 10px;
    padding: ${({ padding = "15px" }) => padding};
    border-radius: 5px;
    position: relative;
    transition: 0.35s;
    &, & input, & label {
        user-select: none;
        cursor: pointer;
    }
    & label {
        font-weight: 500;
        user-select: none;
        color: ${({ labelColor = "var(--light-gray-4)" }) => labelColor};
    }
    &.box {
        align-items: center; 
        margin: 0;
        & label {
            font-size: 14px;
        }
        & input {
            display: none;
        }
        &.small {
            & label {
                font-size: 12px;
            }
            & .box {
                --size: 14px;
            }
        }
    }
    &.square {
        background-color: var(--light-blue-2);
        flex-direction: column;
        width: 110px;
        height: 90px;
        padding: 12px;
        box-sizing: border-box;
        & label {
            color: var(--dark-4);
            position: absolute;
            font-size: 14px;
            font-weight: 600;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    &.switch {
        align-items: center;
        flex-direction: row-reverse;
        & label {
            font-size: 16px;
        }
        & > div {
            width: 48px;
            height: 20px;
            border-radius: 16px;
            background-color: var(--light-gray-4);
            position: relative;
            transition: 0.4s;
            &::after {
                content: "";
                position: absolute;
                top: 50%;
                left: -2%;
                transform: translateY(-50%);
                background-color: var(--light-1);
                width: 27px;
                height: 27px;
                box-sizing: border-box;
                border-radius: 50%;
                border: 2.3px solid var(--light-gray-4);
                transition: inherit;
            }
            &.checked {
                background-color: var(--purple-1);
                &::after {
                    left: 102%;
                    transform: translate(-100%, -50%);
                    border-color:  var(--purple-1);
                }
            }
        }
        &.small {
            & > div {
                width: 38px;
                height: 16px;
                &::after {
                    width: 22px;
                    height: 22px;
                }
            }
            & label {
                font-size: 14px;
            }
        }
    }
    &.disabled {
        & label {
            color: var(--purple-4);
        }
        pointer-events: none;
    }
    &.error {
        &.square {
            & input::after {
                box-sizing: border-box;
                border: 1.5px solid var(--red-3);
            }
        }
    }
`;
export const Box = styled.div`
    --size: 16px;
    width: var(--size);
    height: var(--size);
    position: relative;
    border: 1.5px solid var(--light-gray-4);
    border-radius: 2px;
    cursor: pointer;
    & svg {
        display: block;
        transition: 0.2s;
        width: calc(100% + 1.5px);
        height: calc(150%) !important;
        transform: translate(-1px, -4.3px);
    }
    &:not(.checked) svg {
        opacity: 0;
        visibility: hidden;
    }
    &.disabled {
        border-color: var(--purple-4);
        & svg rect {
            fill: var(--purple-4);
            stroke: var(--purple-4);
        }
    }
`;
export const StyleInput = styled.input`
    position: relative;
    appearance: none;
    width: 18px;
    height: 18px;
    &::after {
        content: "";
        position: absolute;
        display: block;
        top: 50%;
        left: 50%;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        background: none no-repeat center;
        background-color: var(--light-1);
        border-radius: 2px;
        transform: translate(-50%, -50%);
        box-sizing: border-box;
        border: 2px solid var(--light-gray-4);
    }
    &:checked::after {
        border-color: transparent;
        width: 100%;
        height: 100%;
        background-image: url(${boxIcon});
    }
`;
export const Description = styled.label`
    color: var(--dark-4);
    font-weight: bold;
    font-size: 14px;
    &.disabled {
        color: var(--purple-4);
    }
`;